import {
  Header,
  Hero,
  About,
  Resume,
  Portfolio,
  Blogs,
  Contact,
  Footer,
} from "./app/components/sections";

function App() {
  return (
    <>
      <Header />
      <Hero />
      <About />
      <Resume />
      <Portfolio />
      <Blogs />
      <Contact />
      <Footer />
    </>
  );
}

export default App;
